const loadScript = function (url, callback) {
  const script = document.createElement('script')
  const head = document.getElementsByTagName('head')[0]
  script.type = 'text/javascript'

  if (script.readyState) {
    // IE
    script.onreadystatechange = function () {
      if (
        script.readyState === 'loaded' ||
        script.readyState === 'complete'
      ) {
        script.onreadystatechange = null
        head.removeChild(script)
        callback && callback()
      }
    }
  } else {
    // Others
    script.onload = function () {
      head.removeChild(script)
      callback && callback()
    }
  }
  script.src = url
  head.appendChild(script)
}
const seriParam = function (paramObj, isEncode) {
  let param = ''
  const ownProperty = Object.prototype.hasOwnProperty
  for (const key in paramObj) {
    if (ownProperty.call(paramObj, key)) {
      param += key + '=' + (isEncode ? encodeURIComponent(paramObj[key]) : paramObj[key]) + '&'
    }
  }
  return param.substring(0, param.length - 1)
}
const getQueryString = function () {
  let g
  let h
  const b = {}
  let d = null
  let e = null
  let f = null
  const a = location.search.length ? location.search.substring(1) : ''
  const c = a.split('&')
  if (c) {
    for (g = 0, h = c.length; h > g; g++) {
      d = c[g].split('=')
      e = decodeURIComponent(d[0])
      f = decodeURIComponent(d[1])
      b[e] = f
    }
  }
  return b
}
const refreshPageByBack = function () {
  console.log('执行了！！！！！')
  const isIOS = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  // eslint-disable-next-line
  if (!!isIOS) {
    let isPageHide = false
    console.log('------> page <--------')
    window.addEventListener('pageshow', function () {
      if (isPageHide) {
        console.log('------> pageshow <------')
        window.location.reload()
      }
    })
    window.addEventListener('pagehide', function () {
      console.log('------> pagehide <------')
      isPageHide = true
    })
  }
}

const removeObjectKeys = (obj, keysToRemove) => {
  return Object.keys(obj).reduce((acc, key) => {
    if (!keysToRemove.includes(key)) {
      acc[key] = obj[key]
    }
    return acc
  }, {})
}

export {
  loadScript,
  seriParam,
  getQueryString,
  refreshPageByBack,
  removeObjectKeys
}
